import React, { useState, useEffect, useContext } from 'react';
import { CrudCategories } from '../../Components/Cruds/CrudCategories';
import { CrudArticleTypes } from '../../Components/Cruds/CrudArticleTypes';
import { getUserPermissionsByUserEmail } from '../../api/usersModule/getters';
import { NotFoundPage } from '../NotFoundPage/NotFoundPage';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import './ArticlesCategoriesPage.css';
import UserContext from '../../utils/Contexts/UserContext';

const moduleName = 'Tipo de artículos y categorías';
export const ArticlesCategoriesPage = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('article-types');
  const user = useContext(UserContext);

  const getPermissions = async () => {
    setLoading(true);

    let permissions = {
      Consultar: false,
      Crear: false,
      Editar: false,
      Eliminar: false,
    };

    try {
      permissions = await getUserPermissionsByUserEmail(
        user.attributes['email'],
        user.attributes['custom:project'],
        moduleName
      );
      try {
        permissions['Consultar']
          ? setUserPermissions(permissions)
          : setUserPermissions([]);
      } catch (error) {
        permissions['Consultar'] = false;
      }
      setUserPermissions(permissions);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {userPermissions['Consultar'] ? (
        <div className="articles-categories-page">
          <div className="page-header">
            <h2>Gestión de Tipos de Artículos y Categorías</h2>
            <p>Administra los tipos de artículos y categorías del sistema</p>
          </div>
          
          <div className="page-content">
            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={`tab-button ${activeTab === 'article-types' ? 'active' : ''}`}
                  onClick={() => setActiveTab('article-types')}
                >
                  <i className="fas fa-tags"></i>
                  Tipos de Artículos
                </button>
                <button
                  className={`tab-button ${activeTab === 'categories' ? 'active' : ''}`}
                  onClick={() => setActiveTab('categories')}
                >
                  <i className="fas fa-boxes"></i>
                  Categorías
                </button>
              </div>
              
              <div className="tab-content">
                {activeTab === 'article-types' && (
                  <div className="tab-pane active">
                    <CrudArticleTypes
                      userName={user.attributes['email']}
                      permissions={userPermissions}
                      project={user.attributes['custom:project']}
                    />
                  </div>
                )}
                
                {activeTab === 'categories' && (
                  <div className="tab-pane active">
                    <CrudCategories
                      userName={user.attributes['email']}
                      permissions={userPermissions}
                      project={user.attributes['custom:project']}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : loading ? (
        <LoadingPage />
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};